export default __webpack_public_path__ + "static/media/warning.d8189a1a.svg";